import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import CollectionBoxes from "./CollectionBoxes";
import PillSection from "./PillSection";

import colors from "core/colors";

import Heading from "core/Heading";

const BalanceHeading = styled(Heading).attrs({
    type: "h2",
    size: "xl",
    headingColor: colors.secondary.orca,
    bottomSpacing: "5xl",
    alignment: "center"
})`
    text-wrap: balance;
`;

const Collections = ({ id, title, collections, pillsTitle, pills, isLink }) => {
    const hasPills = pills && Object.keys(pills).length > 0;

    return (
        <>
            {title && (
                <BalanceHeading
                    type="h2"
                    size="xl"
                    headingColor={colors.secondary.orca}
                    bottomSpacing="5xl"
                    alignment="center"
                >
                    {title}
                </BalanceHeading>
            )}
            <CollectionBoxes
                id={id}
                collections={collections}
                isLink={isLink}
            />
            {hasPills && <PillSection pillsTitle={pillsTitle} pills={pills} />}
        </>
    );
};

Collections.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    collections: PropTypes.array.isRequired,
    pillsTitle: PropTypes.string,
    pills: PropTypes.array,
    isLink: PropTypes.bool
};

export default Collections;
